import React, { ReactNode, useState, useRef, useEffect } from 'react';
import cN from 'classnames';
import { useMediaQuery } from 'react-responsive';
import styles from './styles.module.scss';

interface I_Props {
    content: ReactNode;
    bubblewidth?: number;
    showBubble: boolean;
    children: React.ReactChild;
}

const BubbleBox: React.FC<I_Props> = ({ children, content, bubblewidth = 304, showBubble }) => {
    const bodyRef = useRef<HTMLDivElement>(null);
    const [containerleft, setcontainerleft] = useState<number>(0);
    const [isActive, setIsActive] = useState<boolean>(false);
    const ismobile = useMediaQuery({ query: '(max-width: 980px)' });

    useEffect(() => {
        const width = bodyRef!.current!.offsetWidth;
        setcontainerleft(width);
    }, [bodyRef?.current?.offsetWidth]);

    useEffect(() => {
        const Timer = setTimeout(() => {
            if (isActive) setIsActive(false);
        }, 2000);
        () => clearTimeout(Timer);
    }, [isActive]);

    return (
        <span
            className={cN(styles.container, 'BubbleBox', { [`${styles.active}`]: isActive })}
            ref={bodyRef}
            onMouseLeave={() => setIsActive(false)}
            onClickCapture={() => (showBubble ? setIsActive(true) : void 0)}
        >
            {children}
            <div
                className={styles.bubbleContent}
                style={{
                    width: bubblewidth,
                    // left: !ismobile ? -(bubblewidth / 2 - containerleft / 2) : 0,
                }}
            >
                {content}
            </div>
        </span>
    );
};

export default BubbleBox;
